import { Routes, RouterModule } from '@angular/router';
import {AUTH_ROUTES} from '@pages/auth/auth.routes';

export const AUTH_LAYOUT_ROUTES: Routes = [
  {path: '', children: AUTH_ROUTES}
];
